// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","highlight":"Header_highlight__3-0I8","highlightTitle":"Header_highlightTitle__2h5cY","highlightContent":"Header_highlightContent__1MStn"};